







































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { IRawDailyDataSumParam } from '../interfaces';
import { EnergyDisplay } from '../interfaces';

// you need to ts-ignore this line or TS will complain about the lack of type definitions
// there could be a more elegant solution though
// @ts-ignore
import InternalBarChart from '@/components/InternalBarChart.js';

@Component({
    components: {InternalBarChart},
})
export default class Electricity extends Vue {
    private dialog: boolean = false;
    private notifications: boolean = false;
    private sound: boolean = true;
    private widgets: boolean = false;

    private loaded: boolean = false;

    private chartWidth: number = 300;
    private chartHeight: number = 300;
    private startDate: moment.Moment = moment().startOf('week');
    private endDate: moment.Moment = moment().endOf('week');

    // public async mounted() {
    //   const self = this;
    //   this.loaded = false;

    //   const payload: IRawDailyDataSumParam = {meterType: 'import', startDate: this.startDate, endDate: this.endDate};

    //   await Promise.all([this.$store.dispatch('getHouseMeterRawDailyDataSumBetweenDates', payload),
    //                     ]).then((values) => {

    //         self.chartdata = {};
    //         self.loaded = true;
    //   });
    // }

    public async mounted() {
    this.refreshData();
  }

  public async refreshData() {
    // do an API call here and touch properties that will cause chartData() and chartOptions() to be called
    // Because of the reactiveProp mixin inside InternalChart.js, the chart will update automagically :)
  }


// {
//             label: 'Export',
//             data: [2, 9, 3, 2, 1, 4, 3],
//             backgroundColor: [
//                 'rgba(255, 99, 132, 0.2)',
//                 'rgba(54, 162, 235, 0.2)',
//                 'rgba(255, 206, 86, 0.2)',
//                 'rgba(75, 192, 192, 0.2)',
//                 'rgba(153, 102, 255, 0.2)',
//                 'rgba(255, 159, 64, 0.2)',
//                 'rgba(255, 159, 64, 0.2)',
//             ],
//             borderColor: [
//                 'rgba(255, 99, 132, 1)',
//                 'rgba(54, 162, 235, 1)',
//                 'rgba(255, 206, 86, 1)',
//                 'rgba(75, 192, 192, 1)',
//                 'rgba(153, 102, 255, 1)',
//                 'rgba(255, 159, 64, 1)',
//                 'rgba(255, 159, 64, 1)',
//             ],
//             borderWidth: 1,
//         }

  public chartData(): object {
    // chart js DATA object. See https://www.chartjs.org/docs/latest/getting-started/usage.html
    return {
      labels: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      datasets: [{
            label: 'Import',
            data: [12, 19, 3, 5, 2, 3, 12],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
                'rgba(255, 99, 132, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
                'rgba(255, 99, 132, 1)',
            ],
            borderWidth: 1,
        },
        {
            label: 'Export',
            data: [2, 9, 3, 2, 1, 4, 3],
            backgroundColor: [
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(54, 162, 235, 0.2)',
            ],
            borderColor: [
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(54, 162, 235, 1)',
            ],
            borderWidth: 1,
        },
        {
            label: 'Solar Generated',
            data: [4, 11, 6, 8, 9, 6, 5],
            backgroundColor: [
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(255, 206, 86, 0.2)',
            ],
            borderColor: [
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(255, 206, 86, 1)',
            ],
            borderWidth: 1,
        },
        {
            label: 'Solar used in home',
            data: [3, 9, 4, 3, 3, 4, 3],
            backgroundColor: [
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
                'rgba(100, 202, 100, 0.2)',
            ],
            borderColor: [
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
                'rgba(100, 202, 100, 1)',
            ],
            borderWidth: 1,
        }],
    };
  }

  public chartOptions(): object {
    // chart js OPTIONS object. See https://www.chartjs.org/docs/latest/getting-started/usage.html
    return {
        title: {
          display: true,
          text: 'Solar Data Pierce House',
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (tooltipItem: any, data: any) => {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              label += tooltipItem.yLabel.toFixed(3);
              return label;
            },
          },
        },
        display: true,
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true,
          }],
        },
      };
  }
}
